import utils from 'utils';
import STACKS from 'constants/stacks';
import { gmiRequest } from 'actions/request';
import actions from '@ehi/global-marketing-interface/lib/actions';
import services from '@ehi/global-marketing-interface/lib/services';

/**
 * This request goes to GMA first then GMA passes it to IBM.  This could be a source of bugs.  Originally GMA was not passing
 * the style sheet to IBM.  We give IBM three main URLS.  The first two being a `success_url` and a `failure_url`.  In the
 * event of a failure/success the IBM iframe redirects to the appropriate URL.  That URL set up by BE has a post message set up to tell the
 * FE if the payment has been successful or not.  See Review.js, event listener.  We also pass the style_sheet_url, this is the .css
 * file that will style the iframe in which the user enters their payment (CC) information too.
 */
export const cardSubmissionSession =
  ({ isTrueModify, renter_first_name, renter_last_name, loadingOverlay = true }) =>
  (dispatch) => {
    //  TODO: find a more permanent solution
    const style_sheet_url =
      utils.config.getStack() === STACKS.LOCAL
        ? 'https://int1.alamo-np.ie/etc/aweb/vendor/ibmPaymentIframe.css'
        : `${window.location.origin}/etc/aweb/vendor/ibmPaymentIframe.css`;
    return dispatch(
      gmiRequest({
        action: actions.request({
          data: {
            payload: {
              submission_type: 'PAYMENT',
              success_url: `${
                window.location.origin
              }/bin/ibm/redirect?success=true&currentpagepath=${utils.config.getResourcePath()}`, // provide static HTML page
              failure_url: `${
                window.location.origin
              }/bin/ibm/redirect?success=false&currentpagepath=${utils.config.getResourcePath()}`, // provide static HTML page
              //  TODO: find a more permanent solution
              style_sheet_url, // this will change
              renter_first_name,
              renter_last_name,
            },
          },
          service: services.gma.reservations.cardSubmissionSession,
        }),
        loadingOverlay,
        onComplete: (response) => {
          if (!response.messages && response.submission_context_data) {
            const { session_id } = response.submission_context_data;
            if (!isTrueModify) {
              dispatch(actions.reservations.commitState.set('payment_ids', { payment_ids: session_id }));
            } else {
              // For true modify of a prepay reservation, GBO modify commit request need `payment_id` (string) instead of `payment_ids` (array/string). [GBO-26824]
              // And just for safety `payment_ids` should be cleared/unset.
              dispatch(actions.reservations.commitState.unset('payment_ids'));
              dispatch(actions.reservations.commitState.set('payment_id', { payment_id: session_id }));
            }
          }

          return response;
        },
      })
    );
  };
